export default __webpack_public_path__ + "static/logo-alfredo-black-b117e3ca9c7f546125372296b9f3b4b0.png";